/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faDiscord } from '@fortawesome/free-brands-svg-icons'
import { faLink } from '@fortawesome/free-solid-svg-icons'

type Props = {
    logo: any
    name: string
    description: string
    twitter?: string
    url?: string
    discord?: string
}

const Card = ({ logo, name, description, twitter, url, discord }: Props) => {
    return (
        <div className='bg-primary-light shadow-xl py-7 px-8 rounded-md text-center'>
            <img src={logo} className='w-28 h-28 rounded-full block mx-auto mb-2' alt={name} />
            <h1 className='text-gray-100 text-2xl font-medium mb-2'>{name}</h1>
            <p className='text-gray-300 text-sm mb-5'>{description}</p>
            <div className='flex items-center justify-center'>
                {twitter &&
                    <div className='twitter px-2.5'>
                        <a href={twitter}>
                            <FontAwesomeIcon icon={faTwitter} className='text-purple-500 hover:text-purple-400 text-2xl transition' />
                        </a>
                    </div>
                }
                {url &&
                    <div className='link px-2.5'>
                        <a href={url}>
                            <FontAwesomeIcon icon={faLink} className='text-purple-500 hover:text-purple-400 text-2xl transition' />
                        </a>
                    </div>
                }
                {discord &&
                    <div className='discord px-2.5'>
                        <a href={discord}>
                            <FontAwesomeIcon icon={faDiscord} className='text-purple-500 hover:text-purple-400 text-2xl transition' />
                        </a>
                    </div>
                }
            </div>
        </div>
    )
}

export default Card